import React from 'react';

export default class Card extends React.Component {
  renderHeader() {
    return <div className="card-header">{this.props.header}</div>;
  }

  renderFooter() {
    return <div className="card-footer">{this.props.footer}</div>;
  }

  render() {
    const customAttr = this.props.onClick
      ? {
          style: { cursor: 'pointer' },
          role: 'link',
          tabIndex: '0',
          onClick: () => this.props.onClick(),
          onKeyPress: () => this.props.onClick(),
        }
      : {};

    let padding = this.props.padding ? '' : 'no-padding';
    if (typeof this.props.padding === 'undefined') {
      padding = '';
    }

    return (
      <div
        className={'card card-status ' + this.props.className + ' ' + padding}
        {...customAttr}
      >
        {this.props.header ? this.renderHeader() : null}
        <div className="card-content">{this.props.children}</div>
        {this.props.footer ? this.renderFooter() : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/Card.js